<template>
  <div class="card-carousel" id="debug_id_2">
    <!-- Left Button -->
    <button class="button-spin counterclockwise" @click="rotateCarousel(1)">&lt;</button>
    <div class="inner-carousel" ref="innerCarousel">
      <!-- Card Wrapper -->
      <div v-for="(card, index) in cards" :key="index" :style="card.styleObject" :class="card.cardClass" @click="handleCardClick(index, card)">
        <!-- Card Content -->
        <div :class="{'back': card.isBack}">
          <h4>{{ card.title }}</h4>
          <p>{{ card.description }}</p>
          <a href="#">Blame the wizards!</a>
        </div>
      </div>
    </div>
    <!-- Right Button -->
    <button class="button-spin clockwise" @click="rotateCarousel(-1)">&gt;</button>
  </div>
</template>

<script>
export default {
  name: "video-card-slider",
  props: {
    cardData: {
      type: Array,
      required: true,
    },
    videos: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      rotateInt: 0,
      cards: [],
    };
  },
    mounted() {
    this.$nextTick(() => {
      this.animateSlider();
    });
  },
  created() {
    this.cards = this.cardData.map((item, index) => {
      return {
        title: item.title,
        description: item.description,
        cardClass: this.getCardClass(index),
        styleObject: this.getCardStyle(index),
        isBack: false,
      };
    });
  },
  methods: {
    rotateCarousel(direction) {
      console.log('direction',direction);
      this.rotateInt += direction;
      this.animateSlider();
    },
    handleCardClick(index, card) {
      //
    },
    animateSlider() {
      const size = this.cards.length;
      const ry = 360 / size;
      this.cards.forEach((card, index) => {
        const z = (this.rotateInt * ry) + (index * ry);
        card.styleObject.transform = `rotateY(${z}deg) translateZ(192.1px) rotateY(${-z}deg)`;
        card.cardClass = this.getCardClass(z);
      });
    },
    getCardStyle(rotation) {
      const translateZ = -225;
      const transform = `rotateY(${rotation}deg) translateZ(${translateZ}px) rotateY(${-rotation}deg)`;
      const zIndex = 2 - Math.abs(Math.floor(rotation / 90));
      const backgroundColor = zIndex === 2 ? "#1C9577" : "";
      const backgroundImage = zIndex === 2
        ? "radial-gradient(circle 200px at center right, #2ABA96, #1C9577)"
        : "";
      const color = zIndex === 2 ? "#fff" : "#000";

      return {
        transform,
        zIndex: zIndex,
        backgroundColor,
        backgroundImage,
        color,
      };
    },
    getCardClass(rotation) {
      const zz = rotation % 360;
      if (zz === 0) {
        return "front";
      } else if (zz === 90 || zz === -270) {
        return "clockwise";
      } else if (zz === -90 || zz === 270) {
        return "counterclockwise";
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.back {
  transform: rotateY(180deg);
  cursor: pointer;
}

h4 {
  font-family: "Open Sans";
  font-weight: 300;
}

p {
  font-size: 12px;
}

.card-carousel {
  position: relative;
  margin: 0 auto 0 auto;
  padding: 0;
  max-width: 220px;
  max-width: 100%;
  height: 450px;
  perspective: 2000px;
  perspective-origin: top;
  .button-spin {
    position: absolute;
    top: 50%;
    border: 0 none;
    background-color: transparent;
    cursor: pointer;
    font-family: "Open Sans";
    font-weight: 800;
    padding: 10px 16px;
    text-shadow: 1px 1px 4px rgba(0, 54, 90, .5);
    &:hover {
      box-shadow: 0px 4px 4px 4px rgba(0, 54, 90, .15);
    }
    &:active {
      box-shadow: none;
    }
  }
  .button-spin.counterclockwise {
    left: 0;
  }
  .button-spin.clockwise {
    right: 0;
  }
  .inner-carousel {
    position: relative;
    width: 225px;
    margin: 0 auto;
    top: 80px;
    transform-style: preserve-3d;
    
    > div {
      position: absolute;
      margin: 0 auto;
      padding: 20px;
      width: 220px;
      height: 300px;
      opacity: 1;
      background-color: #fff;
      color: #000;
      border-radius: 10px;
      transition: all .5s ease-out;
      z-index: 1;
      box-shadow: 0px 10px 10px 10px rgba(0, 54, 90, .15);
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        opacity: .6;
        background-color: #ddd;
        z-index: 1;
      }
      &.counterclockwise:after,
      &.clockwise:after {
        opacity: .4;
        cursor: pointer;
      }
      &.front:after {
        content: none;
      }
      &.front {
        background-color: #1C9577;
        background-image: radial-gradient(circle 200px at center right, #2ABA96, #1C9577);
        color: #fff;
        a {
          box-shadow: 0px 5px 5px 5px rgba(0, 54, 90, .15);
          &:hover,
          &:focus {
            border: 2px solid #48CFAD;
            padding: 5px 0;
          }
          &:active {
            box-shadow: none;
          }
        }
      }
      a {
        position: absolute;
        text-align: center;
        bottom: 30px;
        display: block;
        width: 180px;
        border: 1px solid #c9c9c9;
        border-radius: 16px;
        padding: 6px 0;
        font-size: 12px;
        font-weight: 500;
        color: #000;
        text-decoration: none;
        background-color: #fff;
        box-shadow: 0px 5px 8px 3px rgba(0, 54, 90, .10);
      }
    }
  }
}
</style>
